var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTehnoBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 39,
    viewBox: "0 0 193 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4294 38.1562H21.9505V11.1303H31.9582V1.56398H0.421875V11.1303H10.4294V38.1562ZM48.4587 28.8513V24.0421H62.9087V15.1553H48.4587V10.8689H64.9102V1.56398H37.1329V38.1562H65.5449V28.8513H48.4587ZM94.3473 1.56398V14.5281H83.7051V1.56398H72.1841V38.1562H83.7051V24.6693H94.3473V38.1562H105.868V1.56398H94.3473ZM136.087 1.56398V18.1872L123.101 1.56398H113.63V38.1562H124.858V21.5328L137.844 38.1562H147.315V1.56398H136.087ZM172.993 38.9926C184.123 38.9926 192.276 30.9422 192.276 19.8601C192.276 8.77794 184.123 0.727539 172.993 0.727539C161.862 0.727539 153.71 8.77794 153.71 19.8601C153.71 30.9422 161.862 38.9926 172.993 38.9926ZM172.993 29.0081C168.746 29.0081 165.328 25.558 165.328 19.8601C165.328 14.1622 168.746 10.712 172.993 10.712C177.24 10.712 180.657 14.1622 180.657 19.8601C180.657 25.558 177.24 29.0081 172.993 29.0081Z",
    fill: "#1F1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTehnoBlackLogo);
export default __webpack_public_path__ + "static/media/tehnoBlackLogo.f2b1a68333426b6acf8644fdcc1a5dcd.svg";
export { ForwardRef as ReactComponent };